import { useState } from 'react'

import useNonInitialEffect from '@aytm/app/stats/page/components/hooks/useNonInitialEffect'

// The export's Apply active filters box: ticked while the report carries a filter. A tick the reader set by
// hand is kept only while the filter it was set against is still the applied one; every change of the
// applied filter sets the box again, as the page's filter change always did.
const useApplyFilters = (saved, filtersPattern) => {
  const [applyFilters, setApplyFilters] = useState(
    Object.hasOwn(saved || {}, 'applyFilters') && saved.filtersPattern === filtersPattern
      ? saved.applyFilters
      : 0 < filtersPattern.length
  )

  useNonInitialEffect(() => setApplyFilters(0 < filtersPattern.length), [filtersPattern])

  return [applyFilters, setApplyFilters]
}

export default useApplyFilters
